import { useMutation, useQueryClient } from "@tanstack/react-query";
import invariant from "tiny-invariant";

import { allTasks } from "shared/config/consts/tasks";
import { catchError } from "shared/utils/catch-error";

import { cloudStorageKeys } from "../types";
import { getCloudStorage } from "../utils/get-cloud-storage";
import {
  getCompletedTasksQueryOptions,
  useFetchCompletedTasks,
} from "./use-completed-tasks-query";

type Params = {
  systemName: string;
};

export const useCompleteTaskMutation = () => {
  const queryClient = useQueryClient();
  const fetchCompletedTasks = useFetchCompletedTasks();
  return useMutation({
    mutationFn: async ({ systemName }: Params) => {
      const completedTasks = await fetchCompletedTasks();
      const completedTask = completedTasks.find(
        (task) => task.systemName === systemName
      );
      if (completedTask) return completedTasks;
      const task = allTasks.find((t) => t.systemName === systemName);
      invariant(task, `task not found`);
      const cloudStorage = getCloudStorage();

      const tasks = await queryClient.fetchQuery(
        getCompletedTasksQueryOptions()
      );

      tasks.push({ ...task, status: "completed", completedAt: Date.now() });

      await cloudStorage.setItem(cloudStorageKeys.tasks, JSON.stringify(tasks));

      return tasks;
    },

    onSuccess: (tasks) => {
      queryClient.setQueryData(
        getCompletedTasksQueryOptions().queryKey,
        () => tasks
      );
    },
    onError: (error) => {
      catchError(error);
    },
  });
};
